/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_InfoInputs */



/**
* | output |
* | --- |
* | "Project Info" |
*
* @param {Project_InfoInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const project_info = /** @type {((inputs?: Project_InfoInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_InfoInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Infos du projet")
	if (locale === "de") return /** @type {LocalizedString} */ ("Projektinformationen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Informazioni sul progetto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Информация о проекте")
	if (locale === "es") return /** @type {LocalizedString} */ ("Información del proyecto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("项目信息")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロジェクト情報")
	if (locale === "hi") return /** @type {LocalizedString} */ ("परियोजना की जानकारी")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Informações do projeto")
	return /** @type {LocalizedString} */ ("Project Info")
});